import React, { useState } from "react";
import HeroSearch from "./components/HeroSearch";
import ExclusiveDeals from "./components/ExclusiveDeals";
import SpecialOffers from "./components/SpecialOffers";
import LimitedTimePromo from "./components/LimitedTimePromo";
import ExploreDestinations from "./components/ExploreDestinations";
import TravelCollections from "./components/TravelCollections";

export type TravelMode = "tour" | "cruise";

export default function Homepage() {
  // Tour/Cruise mode is owned here so the hero toggle can drive section content
  // (e.g. the Explore section title changes in cruise mode).
  const [mode, setMode] = useState<TravelMode>("tour");

  return (
    <div id="homepage-v2">
      <HeroSearch mode={mode} onModeChange={setMode} />
      <div className="homepage-v2__content">
        <ExclusiveDeals />
        <SpecialOffers />
        <LimitedTimePromo />
        <ExploreDestinations mode={mode} />
        <TravelCollections />
      </div>
    </div>
  );
}
